
window.CNN = window.CNN || {};
window.CNN.ix = window.CNN.ix || {};
window.CNN.omniture = window.CNN.omniture || {};

document.title = document.title + ' - CNN.com';

// import './jsmd';
// import './chartbeat';
